import { createSelector } from '@reduxjs/toolkit';
import { Report5SAuditsState } from '../../types/report5SAudits';

const selectSlice = (state: any): Report5SAuditsState => state.myTasksStrapi.report5SAudits;

export const selectReport5SChartData = createSelector(
  [selectSlice],
  (slice) => slice.chart.data,
);

export const selectReport5SChartLoading = createSelector(
  [selectSlice],
  (slice) => slice.chart.loading,
);

export const selectReport5SChartError = createSelector(
  [selectSlice],
  (slice) => slice.chart.error,
);
